export default {
    OPEN_STATIC: 'OPEN_STATIC',
    REQUESTING: 'REQUESTING',
    CLOSED: 'CLOSED',
};
